import React from "react";
import { Text } from "@jsq/ds/core";
import { gridCellStyles } from "~/pages/Compliance/Common/GridCellBackgrounds/styles_vanilla.css";
import { formatCountText } from "~/utils/strings";
import {
  baseContainer,
  warningIcon,
  darkIcon,
  warningText,
  darkText,
  greenText,
  lightIcon,
  countText,
} from "./styles_vanilla.css";
import { RefreshStatus, StatusConfig } from "./types";

export const STATUS_CONFIG: Record<RefreshStatus, StatusConfig> = {
  refresh_required: {
    containerClass: `${baseContainer} ${gridCellStyles.warning}`,
    icon: {
      type: "exclamation-triangle",
      className: warningIcon,
      variant: "outline",
    },
    text: {
      content: "Refresh required",
      className: warningText,
    },
  },
  request_sent_overdue: {
    containerClass: `${baseContainer} ${gridCellStyles.warning}`,
    icon: {
      type: "envelope-circle-check",
      className: warningIcon,
      variant: "outline",
    },
    text: {
      content: {
        type: "dynamic",
        render: (data) => {
          const sentCount = data?.tooltipData?.requestSentCount ?? 0;
          return (
            <>
              Request sent (overdue){" "}
              <Text asSpan className={countText}>
                {formatCountText(sentCount, "time")}
              </Text>
            </>
          );
        },
      },
      className: warningText,
    },
  },
  upcoming_refresh: {
    containerClass: `${baseContainer} ${gridCellStyles.warning}`,
    icon: {
      type: "calendar-clock",
      className: warningIcon,
      variant: "outline",
    },
    text: {
      content: "Upcoming refresh",
      className: warningText,
    },
  },
  request_sent: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "envelope-circle-check",
      className: darkIcon,
      variant: "outline",
    },
    text: {
      content: {
        type: "dynamic",
        render: (data) => {
          const sentCount = data?.tooltipData?.requestSentCount ?? 0;
          if (sentCount > 1) {
            return (
              <>
                Request sent{" "}
                <Text asSpan className={countText}>
                  {formatCountText(sentCount, "time")}
                </Text>
              </>
            );
          }
          return "Request sent";
        },
      },
      className: darkText,
    },
  },
  lp_request_in_progress: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "hourglass-start",
      className: darkIcon,
      variant: "outline",
    },
    text: {
      content: "LP request in progress",
      className: darkText,
    },
  },
  pending_review: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "magnifying-glass-plus",
      className: darkIcon,
    },
    text: {
      content: "Pending review",
      className: darkText,
    },
  },
  in_progress: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "sync-alt",
      className: darkIcon,
    },
    text: {
      content: "In progress",
      className: darkText,
    },
  },
  in_review: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "search",
      className: darkIcon,
    },
    text: {
      content: "In review",
      className: darkText,
    },
  },
  no_upcoming_refresh: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "calendar-check",
      className: lightIcon,
      variant: "outline",
    },
    text: {
      content: "No upcoming refresh",
      className: greenText,
    },
  },
  not_required: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    text: {
      content: "Not required for this profile",
      className: darkText,
    },
  },
  no_schedule: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    text: {
      content: "Not required for this profile",
      className: darkText,
    },
  },
  pending_fund_review: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "search",
      className: darkIcon,
    },
    text: {
      content: "Pending fund review",
      className: darkText,
    },
  },
  ready: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "user-plus",
      className: darkIcon,
    },
    text: {
      content: "Ready for review",
      className: darkText,
    },
  },
  closed: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "flag-checkered",
      className: darkIcon,
      variant: "outline",
    },
    text: {
      content: "Closed",
      className: darkText,
    },
  },
  under_review: {
    containerClass: `${baseContainer} ${gridCellStyles.default}`,
    icon: {
      type: "magnifying-glass-plus",
      className: darkIcon,
    },
    text: {
      content: "In review",
      className: darkText,
    },
  },
};
